import {useAtomValue} from "jotai";
import {ApiAtom, ConnectionAtom, isConnectionValid} from "./MetlConnectionProperties.ts";
import {Button} from "@matillion/component-library";
import {useQuery} from "@tanstack/react-query";

import {desiredUrl, SchemeError} from "../../metl-api/util/SchemeCheck.ts";


export function MetlConnectionTest() {
    const connection = useAtomValue(ConnectionAtom)
    const api = useAtomValue(ApiAtom)
    const query = useQuery({
        queryKey: ["api-test", api?.id ?? "-"],
        queryFn: async () => {
            if(!api) throw new Error("No API")
            return api.test()
        },
        staleTime: 0,
        enabled: false
    })
    const error = query.error
    return <div>
        <Button disabled={!isConnectionValid(connection)} waiting={query.isLoading} onClick={() => query.refetch()}>Test Connection</Button>
        {!query.isLoading && !query.isPending && query.isError && <pre>
            An error occurred:
            {(error instanceof Error) ? error.message : JSON.stringify(error)}
        </pre>}
        {!query.isLoading && query.isError && error instanceof SchemeError && <div>
            Please change your current protocol. <a href={desiredUrl(error.desiredScheme)}>Click Here</a>
        </div>}
        {!query.isPending && !query.isLoading && !query.isError && query.data && <div>Test successful</div>}
    </div>
}